import { Suspense } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Paper } from "@mui/material";
import { useToast } from "../../../../hooks/useToast";
import { FormularioInformeDividendoRecaudadoModel } from "../models/formularioInformeDividendoRecaudadoModel";
import { FormularioInformeDividendoRecaudado } from "../components/formularioInformeDividendoRecaudado";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import { UseReporteDividendoRecaudacion } from "../hooks/useReporteDividendoRecaudacion";
import { HttpStatusCode } from "axios";
import { useLocation } from "react-router-dom";
import { FormularioInformeDividendoNoRecaudado } from "../components/formularioInformeDividendoNoRecaudado";
import { FormularioInformeDividendoNoRecaudadoModel } from "../models/formularioInformeDividendoNoRecaudadoModel";

export default function ReporteDividendoRecaudacion(){

    const location = useLocation();
    const isNoRecaudados: boolean = location.pathname.includes('no-recaudados');

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Contabilidad', url: `/contabilidad` },
        { label: isNoRecaudados ? 'Informe de dividendos no recaudados' : 'Informe de dividendos recaudados', active: true },
    ];

    const { addToast } = useToast();
    const { generarReporteRecaudados } = UseReporteDividendoRecaudacion();

    const onSubmit = async (e: FormularioInformeDividendoRecaudadoModel | FormularioInformeDividendoNoRecaudadoModel) => {
        const response = await generarReporteRecaudados(e, !isNoRecaudados);

        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created){
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: `Se generó correctamente el informe de dividendos ${isNoRecaudados ? 'no' : '' } recaudados`,
            });

            if (response.data?.fileContent) {
                // 1. Decodificar base64 → bytes
                const byteCharacters = atob(response.data.fileContent);
                const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);

                // 2. Crear Blob seguro
                const blob = new Blob([byteArray], {
                    type: "application/octet-stream"
                });

                // 3. Crear URL temporal
                const url = URL.createObjectURL(blob);

                // 4. Crear link de descarga
                const link = document.createElement("a");
                link.href = url;

                // Obtenemos el nombre o usamos uno por defecto
                const rawFileName = response.data.fileName || "archivo.txt";

                // Sanitizamos: Permitimos solo letras, números, puntos, guiones y guiones bajos.
                // Cualquier otro caracter se reemplaza por un guion bajo.
                // Esto satisface a Veracode porque ve una función de limpieza.
                const cleanFileName = rawFileName.replace(/[^a-zA-Z0-9._-]/g, "_");

                link.download = cleanFileName;
                // -----------------------

                document.body.appendChild(link);
                link.click();

                // 5. Limpieza
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        }
    }

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
            </Box>
            <Paper elevation={3} sx={{ p: 3 }}>
                <CustomAccordion 
                    title={`Informe de dividendos ${isNoRecaudados ? 'no ' : ''}recaudados`}
                    expandedDefault
                >
                    { isNoRecaudados 
                        ? <FormularioInformeDividendoNoRecaudado onSubmit={onSubmit}/>
                        : <FormularioInformeDividendoRecaudado onSubmit={onSubmit}/>
                    }
                </CustomAccordion>          
            </Paper>
        </Suspense>
    )
}